import { List, ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import CreditCardIcon from '@mui/icons-material/CreditCard';

const BG_SECTION     = '#1c1c24';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

const options = [
    { key: 'general',       label: 'General',       icon: <AccountCircleIcon fontSize='small' /> },
    { key: 'privacity',     label: 'Privacy',        icon: <LockOutlinedIcon fontSize='small' /> },
    { key: 'accessibility', label: 'Accessibility',  icon: <TuneIcon fontSize='small' /> },
    { key: 'billing',       label: 'Billing',        icon: <CreditCardIcon fontSize='small' /> },
];

export function UserConfigSideBar({ optionSelected, setOptionClicked }: any) {
    return (
        <Box
            sx={{
                bgcolor: BG_SECTION,
                borderRadius: '10px',
                border: BORDER_SUBTLE,
                overflow: { xs: 'auto', md: 'hidden' },
                minWidth: { md: 180 },
                width: { xs: '100%', md: 'auto' },
            }}
        >
            <List
                disablePadding
                sx={{
                    display: { xs: 'flex', md: 'block' },
                    flexDirection: { xs: 'row', md: 'column' },
                }}
            >
                {options.map((opt) => {
                    const selected = optionSelected === opt.key;
                    return (
                        <ListItemButton
                            key={opt.key}
                            selected={selected}
                            onClick={() => setOptionClicked(opt.key)}
                            sx={{
                                // vertical mode: left border accent
                                borderLeft: { xs: 'none', md: selected ? `3px solid ${BRAND_RED}` : '3px solid transparent' },
                                // horizontal mode: bottom border accent
                                borderBottom: { xs: selected ? `2px solid ${BRAND_RED}` : '2px solid transparent', md: 'none' },
                                bgcolor: selected ? 'rgba(192,57,43,0.12)' : 'transparent',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' },
                                '&.Mui-selected': { bgcolor: 'rgba(192,57,43,0.12)' },
                                '&.Mui-selected:hover': { bgcolor: 'rgba(192,57,43,0.18)' },
                                py: { xs: 1, md: 1.25 },
                                px: { xs: 1.5, md: 2 },
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: 'center',
                                justifyContent: { xs: 'center', md: 'flex-start' },
                                flex: { xs: 1, md: 'unset' },
                                minWidth: { xs: 64, md: 'unset' },
                                gap: { xs: 0.25, md: 0 },
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    color: selected ? TEXT_PRIMARY : TEXT_SECONDARY,
                                    minWidth: { xs: 'unset', md: 36 },
                                    justifyContent: 'center',
                                    mb: { xs: 0.25, md: 0 },
                                    mr: { xs: 0, md: 0 },
                                }}
                            >
                                {opt.icon}
                            </ListItemIcon>
                            <ListItemText
                                primary={opt.label}
                                primaryTypographyProps={{
                                    fontSize: { xs: '0.65rem', md: '0.875rem' },
                                    fontWeight: selected ? 600 : 400,
                                    color: selected ? TEXT_PRIMARY : TEXT_SECONDARY,
                                    textAlign: { xs: 'center', md: 'left' },
                                    lineHeight: 1.2,
                                }}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Box>
    );
}
